var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSource = function SvgSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeWidth: 1.5,
    d: "M1.5 5c0-1.54 0-2.31.347-2.876.194-.317.46-.583.777-.777C3.189 1 3.96 1 5.5 1s2.31 0 2.876.347c.317.194.583.46.777.777C9.5 2.689 9.5 3.46 9.5 5s0 2.31-.347 2.876c-.194.317-.46.583-.777.777C7.811 9 7.04 9 5.5 9s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.777C1.5 7.311 1.5 6.54 1.5 5ZM2.782 13.782c1.047-1.047 1.57-1.57 2.19-1.72a2.26 2.26 0 0 1 1.056 0c.62.15 1.143.673 2.19 1.72s1.57 1.57 1.72 2.19c.083.347.083.709 0 1.056-.15.62-.673 1.144-1.72 2.19s-1.57 1.57-2.19 1.72a2.26 2.26 0 0 1-1.056 0c-.62-.15-1.143-.673-2.19-1.72s-1.57-1.57-1.72-2.19a2.26 2.26 0 0 1 0-1.056c.15-.62.673-1.143 1.72-2.19ZM13 17c0-1.54 0-2.31.347-2.876.194-.317.46-.583.777-.777C14.689 13 15.46 13 17 13s2.31 0 2.877.347c.316.194.582.46.776.777C21 14.689 21 15.46 21 17s0 2.31-.347 2.877c-.194.316-.46.582-.776.776C19.31 21 18.54 21 17 21s-2.31 0-2.876-.347a2.35 2.35 0 0 1-.777-.776C13 19.31 13 18.54 13 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17 1v8m4-4h-8"
  })));
};
export default SvgSource;